import { motion } from "framer-motion";

export const PageHero = ({ eyebrow, title, description, image }) => (
  <section className="grain-overlay relative overflow-hidden bg-navy-950 pb-20 pt-36" data-testid="page-hero">
    {image && (
      <>
        <img src={image} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-r from-navy-950 via-navy-950/85 to-navy-950/40" />
      </>
    )}
    <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-gold/10 blur-3xl" />
    <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
      {eyebrow && (
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="mb-4 font-mono text-xs font-semibold uppercase tracking-[0.25em] text-gold"
        >
          {eyebrow}
        </motion.p>
      )}
      <motion.h1
        initial={{ opacity: 0, y: 22 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.08, ease: [0.16, 1, 0.3, 1] }}
        className="max-w-3xl font-serif text-4xl font-bold leading-tight tracking-tight text-white sm:text-5xl"
      >
        {title}
      </motion.h1>
      {description && (
        <motion.p
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.18, ease: [0.16, 1, 0.3, 1] }}
          className="mt-5 max-w-2xl text-base leading-relaxed text-slate-300 sm:text-lg"
        >
          {description}
        </motion.p>
      )}
    </div>
  </section>
);
